var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLandingEasy1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 73",
    d: "M12.6304 2.67341L5.83927 7.94798V13.5116L8.18104 19.4364H2.17049L1.07766 20.9538L4.66838 22.7601L6.93209 32.2977L1.7802 42.052L4.8245 46.026L0.53125 49.5665L2.56079 48.9884L6.93209 50L9.9764 46.8208L11.6937 47.9769H13.9574L17.392 43.8584L21.7633 45.8092L27.7739 41.185L35.892 37.5L37.5312 30.2023H34.6431L33.6283 14.8844L28.4764 8.23699L23.949 0L22.2317 2.67341H12.6304Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 288",
    cx: 43.7812,
    cy: 18.5,
    r: 2.5,
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 289",
    cx: 49.9688,
    cy: 23.5,
    r: 1.5,
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 290",
    cx: 43.7812,
    cy: 18.5,
    r: 2.5,
    fill: "#3A7EFC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLandingEasy1);
export default __webpack_public_path__ + "static/media/IcLandingEasy1.1118e3826e587776c06668674d533d86.svg";
export { ForwardRef as ReactComponent };